
import { api,API_BASE_URL } from "../component/constent";

export const loginUser = (data) =>
//   axios.post(`${API_BASE_URL}/auth/login`, data, {
//     withCredentials: true,
//   });
 api.post(`${API_BASE_URL}/auth/login`, data);

export const verifyOtp = (data) =>
  api.post(`${API_BASE_URL}/auth/verify-otp`, data, {
    withCredentials: true,
  });



 export const logoutUser = () => {
  const token = sessionStorage.getItem("token");

  return api.post(
    `${API_BASE_URL}/auth/logout`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


 